import {$oauth2} from '../oauth2/oauth2.js'
import {handleError, handleResponse} from "./handle-error.js"

export function $fetch(path, customOptions = {}, customResponse = handleResponse, customError = handleError) {
  var options = customOptions
  options.credentials = 'omit'
  if (!options.hasOwnProperty('method')) {
    options.method = 'GET'
  }
  if (!options.hasOwnProperty('headers')) {
    options.headers = {}
  }
  if (!options.headers.hasOwnProperty('content-type')) {
    options.headers['content-type'] = 'application/json; charset=utf-8'
  }
  if (!options.headers.hasOwnProperty('accept')) {
    options.headers['accept'] = 'application/json, text/javascript, */*; q=0.01'
  }
  if (!options.headers.hasOwnProperty('accept-language')) {
    options.headers['accept-language'] = 'cs,en-US;q=0.9,en;q=0.8'
  }
  if ($oauth2.hasAccessToken()) {
    options.headers['authorization'] = $oauth2.tokenType() + ' ' + $oauth2.accessToken()
  }
  if (!options.hasOwnProperty('response-type')) {
    options['response-type'] = 'json'
  }
  return fetch(`${$oauth2.appURL}/${path}`, options).then(customResponse).then(response => {
    if (response.status === 204) {
      return null
    } else {
      const contentType = response.headers.get("content-type")
      if (contentType && contentType.indexOf("application/json") !== -1) {
        return response.json()
      } else {
        return response
      }
    }
  }).catch(customError)
}
